import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Po uruchomieniu',
  subtitle: 'Przeglądaj dane listy kontrolnej uruchomienia i ustaw datę przeglądu po uruchomieniu.',
  go_live_checklist: {
    labels: {
      yes: 'Tak',
      no: 'Nie',
    },
    title: 'Lista kontrolna uruchomienia',
    form: {
      is_google_business_available: {
        label: 'Google Business dostępny',
      },
      is_smart_pricing_configured: {
        label: 'Niższe ceny niż Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Ulotka promocyjna wysłana',
      },
      is_menu_fully_configured: {
        label: 'Wszystkie pozycje menu dostępne',
      },
      has_offers_on_competitor_platforms: {
        label: 'Czy restauracja ma aktywne oferty na Wolt, Uber, Lieferando (z wyjątkiem oferty bezpłatnej dostawy)?',
      },
      is_instagram_story_shared: {
        label: 'Relacja na Instagramie udostępniona właścicielowi',
      },
      is_order_system_connected_to_website: {
        label: 'Strona Foodamigos połączona LUB dodano przycisk zamówień online na własnej stronie restauracji',
      },
      google_business_connected_by: {
        label: 'Jak uzyskaliśmy dostęp do Google Business Profile?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Menedżer sprzedaży zaprosił google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Menedżer sprzedaży samodzielnie wysłał pierwsze żądanie z telefonu właściciela',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Menedżer wdrożenia poprosił o dostęp do Google Business Profile (SM nie zaprosił ani nie złożył żądania dostępu)',
          null: 'N/D',
        },
      },
    },
    buttons: {
      save: 'Zapisz',
    },
    toasts: {
      success: 'Zapisano pomyślnie',
      error: 'Nie udało się zapisać',
    },
  },
  post_launch_screening: {
    title: 'Przegląd po uruchomieniu',
    form: {
      screening_date: {
        label: 'Data przeglądu',
      },
    },
    toasts: {
      success: 'Zapisano pomyślnie',
      error: 'Nie udało się zapisać',
    },
    buttons: {
      save: 'Zapisz',
    },
  },
};
